let initTimelineJourney = () => { };

// client side validation of login form
(function ($) {
  const tooltipInit = function () {
    $('[data-toggle="tooltip"]').tooltip();
  };

  const reveal = function () {
    const revealContent = $('[data-reveal]');

    // Open / Edit Forms on Init
    $(revealContent).each(function () {
      $(this).on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const toReveal = $(this).attr('data-reveal');

        $(this).closest('.progress-content').addClass('hidden');
        $(this).closest('.component-timeline_journey-card').find('.hide-details').addClass('d-none');
        $(this).closest('.component-timeline_journey-card').find('#' + toReveal).removeClass('hidden');
      });

      // Open / Edit Forms After Submitting Move Leg (Depricate above method due to Knockout Bindings)
      const editLink = '.progress-content_edit-details a';

      $(document).on('click', editLink, function () {
        $(this).closest('.component-timeline_journey-card').addClass('editCurrent');
        $(this).closest('.component-timeline_journey-card.editCurrent').find('#' + $(this).attr("data-reveal")).removeClass('hidden');
        $(this).closest('.component-timeline_journey-card.editCurrent').find('.hide-details').addClass('d-none');
        $(this).closest('.progress-content').addClass('hidden');
      });

      const formLink = '.progress-content .showForm';

      $(document).on('click', formLink, function () {
        $(this).closest('.component-timeline_journey-card').addClass('addCurrent');
        $(this).closest('.component-timeline_journey-card.addCurrent').find('.showEdit').removeClass('hidden');
        $(this).closest('.progress-content').addClass('hidden');
      });

      const cancleForm = '.progress-content .cancleleg';

      $(document).on('click', cancleForm, function () {
        $(this).closest('.component-timeline_journey-card').addClass('cancleCurrent');
        $(this).closest('.component-timeline_journey-card.cancleCurrent').find('.progress-content .progress-content.hidden').removeClass('hidden');
        $(this).closest('.component-timeline_journey-card.cancleCurrent').find('.progress-content.showEdit').addClass('hidden');
        $(this).closest('.component-timeline_journey-card.cancleCurrent').find('.hide-details').removeClass('d-none');
      });
    });
  };

  const legInProgress = function () {
    if ($('.component-timeline_journey').length) {
      const showForm = $('.showForm');
      const scheduleLater = $('.cancleleg');
      const editDetails = $('.progress-content_edit-details a');
      const timelineJourney = $('#component-timeline-journey');
      const card = $('.component-timeline_journey-card');

      $('body').on('click', '.showForm', (e) => {

        e.preventDefault();
        $('.InProgress').removeClass('InProgress');
        $(e.currentTarget).closest('.component-timeline_journey-card').addClass('InProgress');
      });

      $('body').on('click', '.cancleleg', (e) => {
        e.preventDefault();
        $('.InProgress').removeClass('InProgress');

        // Hide the confirmation text area if it's present
        var moveLeg = $(e.currentTarget).closest('.component-timeline_journey-card');
        moveLeg.find('.confirmation-texts').addClass('d-none');

        // Remove Quote ID
        moveLeg.removeAttr('data-quoteId');

        // Update button text back to the edit text, if it's available
        let confirmationButtonTags = moveLeg.find('.submitForm');
        confirmationButtonTags.each((i, tag) => {
          let confirmationButtonTag = $(tag);
          confirmationButtonTag.html(confirmationButtonTag.attr('data-confirmButtonLabel'));
        });
      });

      $('body').on('click', '.progress-content_edit-details a', (e) => {
        $(e.currentTarget).parent().parent().parent().parent().parent().addClass('InProgress');
      });

      $(scheduleLater).on('click', '.component-timeline_journey-card', (e) => {
        $('.component-timeline_journey-card').removeClass('InProgress');
      });
    }
  };

  initTimelineJourney = function () {
    reveal();
    tooltipInit();
    legInProgress();
  };

  if (typeof delayTimelineInit === 'undefined' || !delayTimelineInit) {
    initTimelineJourney();
  }
}(jQuery));
